module.exports = __webpack_public_path__ + "static/media/sponsor__twitch--white.5bc8120d.png";